import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_3 = { class: "flex min-w-0 flex-col md:col-span-8" }
const _hoisted_4 = { class: "flex min-w-0 flex-col md:col-span-4" }
const _hoisted_5 = { class: "min-w-0 md:col-span-12" }
const _hoisted_6 = { class: "md:col-span-12" }
const _hoisted_7 = { class: "rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-3 lg:grid-cols-[minmax(0,1fr)_auto]" }
const _hoisted_9 = { class: "flex min-w-0 items-center gap-3 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-3 py-2.5" }
const _hoisted_10 = { class: "min-w-0" }
const _hoisted_11 = { class: "truncate text-[15px] font-semibold text-slate-900" }
const _hoisted_12 = { class: "flex shrink-0 flex-wrap gap-2 lg:justify-end" }
const _hoisted_13 = { enctype: "multipart/form-data" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "md:col-span-12" }
const _hoisted_16 = { class: "overflow-hidden rounded-lg border border-slate-200 bg-white shadow-[0_10px_26px_rgba(15,23,42,0.05)]" }
const _hoisted_17 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_18 = { class: "min-w-full divide-y divide-slate-200 text-[15px]" }
const _hoisted_19 = { class: "divide-y divide-slate-100 bg-white" }
const _hoisted_20 = { class: "px-4 py-3" }
const _hoisted_21 = { class: "flex min-w-0 items-center gap-3" }
const _hoisted_22 = { class: "truncate" }
const _hoisted_23 = { class: "text-right px-4 py-3" }
const _hoisted_24 = {
  key: 1,
  class: "px-4 py-8 text-center"
}
const _hoisted_25 = { class: "md:col-span-12" }
const _hoisted_26 = { class: "rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]" }
const _hoisted_27 = { class: "grid grid-cols-1 gap-3 lg:grid-cols-[minmax(0,1fr)_auto]" }
const _hoisted_28 = { class: "flex min-w-0 items-center gap-3 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-3 py-2.5" }
const _hoisted_29 = { class: "w-full" }
const _hoisted_30 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_31 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_32 = { class: "flex min-w-0 flex-col md:col-span-3" }
const _hoisted_33 = { class: "flex shrink-0 flex-wrap gap-2 lg:justify-end" }
const _hoisted_34 = { enctype: "multipart/form-data" }
const _hoisted_35 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Panel, { header: "Văn bản gửi tổ dân phố" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("label", null, "Tiêu đề", -1)),
            _createVNode(_component_InputText, {
              id: "title",
              type: "text",
              modelValue: $setup.documentCreate.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.documentCreate.title) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Hạn trả lời", -1)),
            _createVNode(_component_Calendar, {
              id: "replyDeadline",
              modelValue: $setup.documentCreate.replyDeadline,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.documentCreate.replyDeadline) = $event)),
              showTime: "",
              placeholder: "Chọn hạn trả lời"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[10] || (_cache[10] = _createElementVNode("label", null, "Nội dung", -1)),
            _createVNode(_component_Textarea, {
              id: "content",
              type: "text",
              modelValue: $setup.documentCreate.content,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.documentCreate.content) = $event)),
              placeholder: "Nhập nội dung",
              class: "min-h-[112px]"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mb-4 flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 pb-3" }, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "m-0 text-[15px] font-bold text-slate-900" }, " Tập tin PDF "),
                  _createElementVNode("div", { class: "mt-1 text-[13px] font-medium text-slate-500" }, " Chỉ chấp nhận file PDF ")
                ]),
                _createElementVNode("div", { class: "inline-flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-slate-700" }, [
                  _createElementVNode("i", { class: "pi pi-file-pdf" }),
                  _createElementVNode("span", null, "Cho phép chọn nhiều file")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-red-50 text-red-700" }, [
                    _createElementVNode("i", { class: "pi pi-file-pdf" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString($setup.listFileName.length > 0
                        ? `Đã chọn ${$setup.listFileName.length} tập tin`
                        : "Chưa chọn tập tin"), 1),
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-sm text-slate-500" }, " Có thể chọn nhiều PDF cùng lúc ", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_Button, {
                    outlined: "",
                    label: "Chọn PDF",
                    icon: "pi pi-paperclip",
                    onClick: $setup.triggerFilePicker,
                    disabled: $setup.loadingBar
                  }, null, 8, ["onClick", "disabled"])
                ])
              ])
            ]),
            _createElementVNode("form", _hoisted_13, [
              _createElementVNode("input", {
                ref: "fileInputEl",
                type: "file",
                class: "hidden",
                accept: ".pdf",
                multiple: "",
                onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.fileChange($event.target.files))),
                disabled: $setup.loadingBar
              }, null, 40, _hoisted_14)
            ])
          ]),
          _createElementVNode("section", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex items-center justify-between border-b border-slate-200 bg-slate-50 px-4 py-3" }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "text-[15px] font-bold text-slate-900" }, " Danh sách PDF "),
                  _createElementVNode("div", { class: "text-[13px] font-medium text-slate-500" }, " Kiểm tra trước khi tải lên. ")
                ])
              ], -1)),
              ($setup.listFileName.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("table", _hoisted_18, [
                      _cache[15] || (_cache[15] = _createElementVNode("thead", { class: "bg-slate-100 text-left text-xs font-bold uppercase text-slate-600" }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "px-4 py-3" }, "Tên file"),
                          _createElementVNode("th", { class: "w-36 px-4 py-3" }, "Dung lượng"),
                          _createElementVNode("th", { class: "w-28 px-4 py-3 text-right" }, "Thao tác")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listFileName, (file) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: file.nameFile,
                            class: "transition hover:bg-red-50/30"
                          }, [
                            _createElementVNode("td", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-red-50 text-red-700" }, [
                                  _createElementVNode("i", { class: "pi pi-file-pdf" })
                                ], -1)),
                                _createElementVNode("span", _hoisted_22, _toDisplayString(file.nameFile), 1)
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString($setup.formatFileSize(file.value?.size)), 1),
                            _createElementVNode("td", _hoisted_23, [
                              _createVNode(_component_Button, {
                                severity: "danger",
                                label: "Xóa",
                                icon: "pi pi-trash",
                                onClick: ($event: any) => ($setup.deleteFile(file.nameFile))
                              }, null, 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "pi pi-file-pdf text-4xl text-slate-300" }, null, -1),
                    _createElementVNode("p", { class: "mt-3 text-sm font-semibold text-slate-600" }, " Chưa có PDF nào được chọn ", -1)
                  ]))]))
            ])
          ]),
          _createElementVNode("section", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "mb-4 flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 pb-3" }, [
                _createElementVNode("div", { class: "inline-flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-slate-700" }, [
                  _createElementVNode("i", { class: "pi pi-users" }),
                  _createElementVNode("span", null, "Chọn người nhận văn bản")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _cache[20] || (_cache[20] = _createElementVNode("span", { class: "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-red-50 text-red-700" }, null, -1)),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _cache[18] || (_cache[18] = _createElementVNode("label", null, "Lựa chọn nhóm", -1)),
                        _createVNode(_component_Dropdown, {
                          id: "group",
                          modelValue: $setup.groupUser,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.groupUser) = $event)),
                          options: $setup.userPermission,
                          optionLabel: "label",
                          optionValue: "value",
                          onChange: $setup.selectGroup
                        }, null, 8, ["modelValue", "options", "onChange"])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _cache[19] || (_cache[19] = _createElementVNode("label", null, "Chọn tài khoản nhận", -1)),
                        _createVNode(_component_MultiSelect, {
                          modelValue: $setup.sendDocument.listId,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.sendDocument.listId) = $event)),
                          options: $setup.listUser,
                          optionLabel: "fullname",
                          optionValue: "id",
                          placeholder: "Chọn tài khoản",
                          filter: true
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_Button, {
                    label: "Gởi văn bản",
                    icon: "pi pi-cloud-upload",
                    onClick: $setup.upload,
                    loading: $setup.loadingBar,
                    disabled: $setup.loadingBar || $setup.listFileName.length < 1 || $setup.sendDocument.listId == null
                  }, null, 8, ["onClick", "loading", "disabled"])
                ])
              ])
            ]),
            _createElementVNode("form", _hoisted_34, [
              _createElementVNode("input", {
                ref: "fileInputEl",
                type: "file",
                class: "hidden",
                accept: ".pdf",
                multiple: "",
                onChange: _cache[6] || (_cache[6] = ($event: any) => ($setup.fileChange($event.target.files))),
                disabled: $setup.loadingBar
              }, null, 40, _hoisted_35)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      header: "Đang tải PDF",
      visible: $setup.loadingBar,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (($setup.loadingBar) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _cache[22] || (_cache[22] = _createElementVNode("label", null, "Đang tải tài liệu lên máy chủ...", -1)),
          _createVNode(_component_ProgressBar, { mode: "indeterminate" })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}